//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import { Box, Flex, Stack, Text } from "@chakra-ui/react";
import React from "react";
import Icon from "./ui-elements/Icon";
import { addDays } from "../utils/functions";
import Countdown from "./data-display/Countdown";
import {
  ACCEPTED_RESPONSE,
  APPLIED_RESPONSE,
  DECLINED_RESPONSE,
  NO_RESPONSE,
  PENDING_RESPONSE,
} from "../stores/jobs/utils/request";

type Props = {
  tutorResponse: any;
  requestStatus: string;
  requestSLUG: string;
  dateCreated: any;
  [key: string]: any;
};

const getRequestStatus = (tutorResponse: string, bookingStatus: string) => {
  const pending = tutorResponse === PENDING_RESPONSE;
  const accepted = tutorResponse === ACCEPTED_RESPONSE;
  const declined = tutorResponse === DECLINED_RESPONSE;
  const timedOut = tutorResponse === NO_RESPONSE;
  const applied = tutorResponse === APPLIED_RESPONSE;

  const getPendingDescription = () => {
    if (pending) return "Awaiting your confirmation";
    if (accepted) return "Awaiting client's payment";
    if (declined) return "Booking was declined";
    if (timedOut) return "Request timed out";
  };
  const getInterviewDescription = () => {
    if (pending) return "Awaiting your confirmation";
    if (accepted) return "Client would like to speak";
    if (declined) return "Booking was declined";
    if (timedOut) return "Request timed out";
  };

  const getPaidDescription = () => {
    if (pending) return "Awaiting your confirmation";
    if (accepted) return "Complete steps to book lessons";
    if (declined) return "Booking was declined";
    if (timedOut) return "Request timed out";
  };

  const statusOptions: { [key: string]: any } = {
    completed: {
      color: "orange.500",
      label: "Open",
      description: pending
        ? "Accepting tutor applications"
        : "Awaiting client's confirmation",
    },
    pending: {
      color: "orange.500",
      label: "Pending",
      description: getPendingDescription(),
    },
    request_to_meet: {
      color: "pink.500",
      label: "Interview",
      description: getInterviewDescription(),
    },
    payed: {
      color: "purple.500",
      label: "Paid",
      description: getPaidDescription(),
    },
    booked: {
      color: "green.500",
      label: "Booked",
      description: "Lessons have been booked",
    },
    cold: {
      color: "gray.400",
      label: "Canceled",
      description: "Client has been unresponsive",
    },
    prospective_client: {
      color: "pink.400",
      label: "Deferred",
      description: "Client has moved start date",
    },
    not_reachable: {
      color: "gray.400",
      label: "Deferred",
      description: "Client has been unreachable",
    },
    found_manually: {
      color: "gray.400",
      label: "Deferred",
      description: "Client has been unreachable",
    },
  };

  return statusOptions[bookingStatus];
};

const BookingStatus = ({
  tutorResponse,
  requestStatus,
  requestSLUG,
  dateCreated,
  ...rest
}: Props) => {
  const status = getRequestStatus(tutorResponse.status, requestStatus);
  const stopDate = addDays(dateCreated, 1);

  return (
    <Box px={[5, 6]} {...rest}>
      <Flex direction={["column", "row"]} align="center">
        <Stack
          isInline
          align="center"
          px={2}
          py={1}
          rounded="md"
          bg="neutral.200"
          width={["auto", "fit-content"]}
        >
          <Text
            py="1px"
            px={2}
            fontSize="xs"
            fontWeight="medium"
            color="white"
            bg={status.color}
            rounded="md"
          >
            {status.label}
          </Text>
          <Text fontSize="sm" pr={1}>
            {status.description}
          </Text>
        </Stack>

        <Box boxSize={3} />

        {tutorResponse.status === PENDING_RESPONSE && (
          <Stack
            display={["none", "flex"]}
            isInline
            align="center"
            px={2}
            py={1}
            rounded="md"
            bg="neutral.200"
            width={["auto", "fit-content"]}
          >
            <Icon name="alarm-clock" size={5} color="red.500" />
            <Box fontSize="sm" pr={1}>
              <Countdown date={stopDate} variant="plain" /> left to respond
            </Box>
          </Stack>
        )}
      </Flex>
    </Box>
  );
};

export default BookingStatus;
